import { useEffect, useRef } from 'react';

const typing = (target: EventTarget | null) => target instanceof HTMLElement
  && (target.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName));

/** ⌘/Ctrl+K anywhere; single keys and "g then x" sequences only outside text fields. */
export function useShortcuts(handlers: { palette: () => void; focusSearch: () => boolean; go: (key: string) => void; help: () => void }) {
  const ref = useRef(handlers);
  ref.current = handlers;
  useEffect(() => {
    let pendingG = 0;
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); ref.current.palette(); return; }
      if (e.metaKey || e.ctrlKey || e.altKey || typing(e.target) || e.defaultPrevented) return;
      if (e.key === '/') { e.preventDefault(); if (!ref.current.focusSearch()) ref.current.palette(); return; }
      if (e.key === '?') { e.preventDefault(); ref.current.help(); return; }
      if (e.key === 'g') { pendingG = Date.now(); return; }
      if (pendingG && Date.now() - pendingG < 1200) { pendingG = 0; ref.current.go(e.key.toLowerCase()); }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);
}
